
  import {updateCssClass} from '@/helper/CssClassHelper';
  export default {
    components: {
      OrganizationListingFilter: () =>
        import('@/components/elements/OrganizationListingFilter'),
    },
    props: {
      filterParams: {
        type: String,
        required: false,
        default: '',
      },
      useFacets: {
        type: Boolean,
        required: false,
        default: false,
      },
      facets: {
        type: Object,
        required: false,
        default: undefined,
      },
    },
    data() {
      return {
        dialog: false,
        width: 0,
      };
    },
    mounted() {
      this.setButtonWidth();
      window.addEventListener('resize', this.setButtonWidth);
      window.onscroll = () => {
        this.setButtonWidth();
        if (document.documentElement.scrollTop > 599) {
          updateCssClass(
            'pb-organizationlisting-filter-mobile-button',
            'pb-listing-filter-mobile-fixed-button',
            'pb-listing-filter-mobile-nofixed-button'
          );
        } else {
          updateCssClass(
            'pb-organizationlisting-filter-mobile-button',
            'pb-listing-filter-mobile-nofixed-button',
            'pb-listing-filter-mobile-fixed-button'
          );
        }
      };
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.setButtonWidth);
    },
    methods: {
      setButtonWidth() {
        this.width = window.innerWidth - 24;
      },
      setFilterParams(event) {
        this.$emit('listing-filter', event);
        this.dialog = false;
      },
      setFilterParamsAndResetOrderAndPage(event) {
        this.$emit('listing-filter-button', event);
        this.dialog = false;
      },
      resetFilterParams(event) {
        this.$emit('listing-filter-reset', event);
        this.dialog = false;
      },
      closeModal() {
        this.dialog = false;
      },
    },
  };
